<section>
  <div class="border_container">
    <div class="row align-items-center mx-0 p-1">
      <div class="col-lg-6 col-md-6 col-sm-12 col-12">
        <h6>
          {{ isFormView ? 'Registrar detalle de orden de compra' : 'Detalle de la orden de compra' }}
        </h6>
      </div>
      <div class="col-lg-6 col-md-12 col-sm-12 col-12 d-flex justify-content-end gap-1">
        <app-custom-modal #articleForPurchaseOrder [children]="component" [header]="'Selección de Artículos'"
          [inputs$]="inputsForArticleForPurchaseOrder$" [output$]="outputForArticleForPurchaseOrder$"
          [disabled]="disabledButton" (selectedItems)="getSelectedItems($event)" hidden>
        </app-custom-modal>

        <app-custom-button [label]="'Art. Sin Pedido' " [severity]="'success'" [disabled]="disabledButton"
          (onClick)="openModal(false)" [width]="'7rem'">
        </app-custom-button>

        <app-custom-modal #articleWithOrder [header]="'Selección de Insumos'" [children]="component"
          [inputs$]="inputsForArticleWithOrder$" [output$]="outputForArticleWithOrder$" [disabled]="disabledButton"
          (selectedItems)="getSelectedItemsWithOrder($event)" hidden>
        </app-custom-modal>

        <app-custom-button [label]="'Art. Con Pedido'" [severity]="'success'" [disabled]="disabledButton"
          (onClick)="openModal(true)" [width]="'7rem'">
        </app-custom-button>
      </div>
    </div>
    <div class="row mx-0" [hidden]="!isFormView">
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
        <app-register-purchase-order-detail [purchaseOrderDetailModel]="purchaseOrderDetailModel"
          [purchaseOrderModel]="purchaseOrderModel" (isFormView)="getFormView($event)"
          (updateListDetail)="getPurchaseOrderDetailsForCaptureTable();  updateHeader.emit(true);">
        </app-register-purchase-order-detail>
      </div>
    </div>
    <div class="col-lg-12 col-md-12 col-sm-12 col-12 border">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [checkBoxAction]="checkboxActions" [showCheckbox]="true" [clearSelectionTrigger]="clearSelectionTrigger"
        (onRecoverData)="getPurchaseOrderDetailsForCaptureTable()" (onPageChange)="onPageChange($event)"
        (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>